import React from 'react';
import { SkeletonRegistryItem } from '../SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../SkeletonRegistryCategory';
import { ALPHABETH } from '../../../utils/helper/helper_string';
function simpleAspect(name) {
    return new SkeletonRegistryItem({
        label: name,
        jsx: React.createElement("div", { "data-aspect": name }),
    });
}
export function nestedAspects(names) {
    return new SkeletonRegistryItem({
        label: names.join(','),
        jsx: names
            .slice()
            .reverse()
            .reduce((n, name) => React.createElement("div", { "data-aspect": name }, n), undefined),
    });
}
export class SkeletonRegistryStandardBlocks extends SkeletonRegistryCategory {
    label = 'Standard-Blöcke';
    i = simpleAspect('inner');
    constructor(parent) {
        super(parent);
        super.init();
    }
    hidden = () => new SkeletonRegistryItem({
        label: 'hidden div',
        jsx: React.createElement("div", { style: { display: 'none' } }),
    });
    h = () => this.hidden();
    r = () => simpleAspect('reveal');
    oi = () => nestedAspects(['outer', 'inner']);
    poi = () => nestedAspects(['position', 'outer', 'inner']);
    pi = () => nestedAspects(['position', 'inner']);
    imgie = () => new SkeletonRegistryItem({
        label: '(img) essence',
        jsx: context => {
            const image = context.parentActor;
            return React.createElement("img", { "data-aspect": "essence", src: image.imageThumb.thumbSrc });
        },
    });
    textBasis = () => new SkeletonRegistryItem({
        label: 'Show Textbasis',
        jsx: ({ at }) => React.createElement("span", { key: "tb", dangerouslySetInnerHTML: { __html: at.actor.valueOf.textBasis } }),
    });
    textOutput = () => new SkeletonRegistryItem({
        label: 'Show Textoutput',
        jsx: ({ at }) => React.createElement("span", { key: "to", dangerouslySetInnerHTML: { __html: at.actor.textOutputString } }),
    });
    table = () => new SkeletonRegistryItem({
        label: 'Tabelle',
        jsx: ({ at }) => {
            const table = at.actor;
            const rows = Array.from(Array(table.numberOfRows).keys());
            const columns = Array.from(Array(table.numberOfColumns).keys());
            return (React.createElement("table", { key: at.id, "data-aspect": "inner" },
                React.createElement("tbody", null, rows.map(rowIndex => (React.createElement("tr", { style: { minHeight: 30 }, key: rowIndex }, columns.map(colIndex => (React.createElement("td", { "data-aspect": `cell_${ALPHABETH.charAt(colIndex)}${rowIndex + 1}`, style: { minWidth: 20 }, key: colIndex })))))))));
        },
    });
    /*
    readonly cookieConsent = () =>
      new SkeletonRegistryItem({
        label: 'CookieConsent',
        jsx: () => (
          <div
            key="cc"
            style={{
              position: 'fixed',
              width: 250,
              left: 20,
              bottom: 55,
              zIndex: 2000,
              padding: '2em',
              backgroundColor: '#ccc',
              display: 'flex',
              flexDirection: 'column',
              fontSize: 18,
              borderRadius: 5
            }}
          >
            <p>Diese Website verwendet Cookies zu Werbezwecken und zur Verbesserung des Angebots.</p>
            <a href="/seiten/impressum.php" target="_blank" style={{ marginBottom: 30 }}>
              Mehr erfahren
            </a>
  
            <button
              style={{
                background: '#37cd8f',
                color: '#fff',
                border: 'none',
                boxShadow: '1px 1px 3px rgba(100,100,100,0.7)',
                borderRadius: 5,
                fontWeight: 'bold',
                fontSize: '1.2em',
                padding: '.6em .8em',
                margin: 2,
                lineHeight: '.8em',
                cursor: 'pointer',
                outline: 'none'
              }}
              onClick={() => {
                runtime.solidBrowserRuntime.app.appCookies.reactiveCookies.set('cookieconsent_status', 'dismiss');
                if (runtime.solidBrowserRuntime.browserFullscreen.shouldTriggerFullscreen) {
                  runtime.solidBrowserRuntime.browserFullscreen.requestFullScreen();
                }
              }}
            >
              Akzeptieren
            </button>
          </div>
        )
      });
  */
    aspectContent = () => new SkeletonRegistryItem({
        label: 'Aspect Content',
        jsx: ({ aspect, at }) => {
            const aspectName = at.trait.local.valueOf.aspectName;
            if (aspectName === aspect.name)
                return null; // avoid recursion
            return aspect.actor.ownAspect[aspectName].aspectJsx.jsxChildren_fromTraits;
        },
        params: { core: ['aspectName'] },
    });
}
